module.exports = __webpack_public_path__ + "static/testimonial-pic-1-e2d0046dbf687577cc684bdc5f47e298.jpg";